import React from 'react';

import './index.scss';

// import modifyImage from 'assets/icon_hensyuu.svg';
import {ReactComponent as ReactLogo}  from 'assets/icon_hensyuu.svg';
const ModifyButton = ({ onClick }) => {
  return (
    <div className='ModifyButton'>
      <button
        className=""
        type="button"
        onClick={onClick}
      >
        <span className='A-MB-icon'>
          <ReactLogo/>
        </span>
        {/* <img className='A-MB-icon' src={modifyImage} alt="modify" /> */}
      </button>
    </div>
  );
};

export default ModifyButton;